// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2i4Vm","info":"PatientInfo_info__11eeG"};